module.exports = __webpack_public_path__ + "img/help1.54e339ce.png";